import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs';
import { TaskDialogService } from '../../taskbook-dialog.service';
import { TaskbookService } from "../../taskbook.service";
import { TaskAssignee } from "../../taskbook.types";

@Component({
    selector: 'task-assignee-popover',
    templateUrl: './task-assignee-popover.component.html',
    styleUrls: ['./task-assignee-popover.component.scss', './../../taskbook-triage-actions/taskbook-triage-actions.component.scss', './../../task/task.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule
    ]
})
export class TaskAssigneePopoverComponent implements OnChanges {
    protected availableAssignees: TaskAssignee[] = [];

    @Input() context: string;
    @Input() managers: TaskAssignee[];
    @Input() selectedAssignees: TaskAssignee[];
    @Output() assigneesChange = new EventEmitter<TaskAssignee[]>();
    @Output() apply = new EventEmitter<TaskAssignee[]>();
  
    constructor(
      private taskbookService: TaskbookService,
      private cdr: ChangeDetectorRef,
    ) {}
  
    ngOnChanges(): void {
    }

    setSelectedClass(assignee: TaskAssignee): string {
      return this.selectedAssignees.filter(l => l.id === assignee.id).length > 0 ? 'selected' : '';
    }

    applyAssignees(selectedAssignees: TaskAssignee[]): void {
      this.apply.emit(selectedAssignees);
      this.selectedAssignees = [];
    }
  
    toggleAssignee(assignee: TaskAssignee): void {
      if (this.selectedAssignees.filter(l => l.id === assignee.id).length > 0) {
        this.selectedAssignees = this.selectedAssignees.filter(l => l.id !== assignee.id);
      } else {
        this.selectedAssignees.push(assignee);
      }
      this.assigneesChange.emit(this.selectedAssignees);
    }
  }

